import CompanySite from 'models/CompanySite';
import Job from 'models/Job';

import Component from './component';

export interface Props {
	company?: CompanySite;
	aboutUsTitle?: string;
	galleryTitle?: string;
	historyTitle?: string;
	benefits?: {
		headline: string;
		icon: string;
	};
	stagesTitle?: string;
	jobs?: {
		title: string;
		job: {
			saveLabel: string;
			mapLabel: string;
		};
	};
	jobsList?: Job[];
	isEditable?: boolean;
	translations?: Props;
}

Component.defaultProps = {};

export default Component;
